import { render, staticRenderFns } from "./domain.vue?vue&type=template&id=ba6473f0&scoped=true"
import script from "./domain.vue?vue&type=script&lang=js"
export * from "./domain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6473f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\dianlala_project\\电啦啦\\cd-vue-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba6473f0')) {
      api.createRecord('ba6473f0', component.options)
    } else {
      api.reload('ba6473f0', component.options)
    }
    module.hot.accept("./domain.vue?vue&type=template&id=ba6473f0&scoped=true", function () {
      api.rerender('ba6473f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wx/domain.vue"
export default component.exports